import { useEffect, useState } from 'react';
import { getSchoolProfileRequest } from '../../features/schoolProfile/schoolProfileSlice';
import { useAuth } from '../../hooks/useAuth';
import MainLayout from '../../layouts/MainLayout';
import AppRoutes from '../../routes/AppRoutes';
import '../../styles/main.scss';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchUsersRequest } from '../../features/user/userSlice';
import { checkSessionAPI, refreshTokenAPI } from '../../api/auth/authService';
import { handleLogout } from '../../services/logoutHandler';
import { useSnackbar } from '../MUIComponent/FeedbackComponent/SnackBar/SnackbarContext';
import { useCommonFetchInit } from '../../api/commonFetch';
import { useGlobalFlowCleanup } from "../../hooks/useGlobalFlowCleanup";

const AppContent = ({ tenant }) => {
  useCommonFetchInit();
  useGlobalFlowCleanup();
  const { user } = useAuth();
  const { showSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const schoolID = user && user.schoolID;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchUsersRequest());
  }, [dispatch]);

  
  useEffect(() => {
    dispatch(getSchoolProfileRequest({ schoolID }));
  }, [user]);

  return (
    <>
      <MainLayout tenant={tenant}>
        <AppRoutes />
      </MainLayout>
    </>
  );
};

export default AppContent;
